import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fillRule="evenodd" d="M16.707 9.293a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-3-3a1 1 0 111.414-1.414L11 13.586l4.293-4.293a1 1 0 011.414 0" clipRule="evenodd" /></svg>;